export enum ColorActionTypes {
    LOAD_COLORS = "LOAD_COLORS",
    RESET_COLORS = "RESET_COLORS",
   
    COLOR_LOAD_COLORS = "color/LOAD_COLORS",
    COLOR_RESET_COLORS = "color/RESET_COLORS",
}